import type { AgentDraft, PreviewDraftEdit, UpsertAgentPrintAreaInput } from './types';

type Point = { x: number; y: number };

/** The gesture edits the same area shown by the drawing card, including after a complete redraw. */
export const gestureAreaEdit = (draft: AgentDraft, sideRef: string, from: Point, to: Point): PreviewDraftEdit<UpsertAgentPrintAreaInput> | null => {
    const variant = draft.document?.product?.variants?.find((item) => item.sides?.some((side) => side.entityReferenceKey === sideRef));
    const side = variant?.sides?.find((item) => item.entityReferenceKey === sideRef);
    const image = side?.image;
    if (!variant?.entityReferenceKey || !draft.revisionNumber || !image?.widthPx || !image.heightPx) return null;
    const area = side?.areas?.[0];
    return {
        variantRef: variant.entityReferenceKey,
        sideRef,
        areaRef: area?.entityReferenceKey ?? null,
        expectedRevisionNumber: draft.revisionNumber,
        name: area?.name ?? null,
        x1: from.x * image.widthPx,
        y1: from.y * image.heightPx,
        x2: to.x * image.widthPx,
        y2: to.y * image.heightPx
    };
};
